<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-overlay :show="loading">
      <b-skeleton animation="wave" width="85%" v-if="loading"></b-skeleton>
       <div v-else>
        <ScheduleNuevo v-if="blnClinicaDescentralizada"/>
        <ScheduleActual v-else/>
       </div>
    </b-overlay>
  </div>
</template>

<script>

import ScheduleActual from "@/views/ScheduleActual";
import ScheduleNuevo from "@/views/ScheduleNuevo";

export default {
  name: "Schedule",
  components: {
    ScheduleNuevo,
    ScheduleActual
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    loading: true,
    blnClinicaDescentralizada: null
  }),
  mounted() {
    this.obtenerClinicaTieneDesentralizado();
  },
  methods: {
    obtenerClinicaTieneDesentralizado() {
      this.loading = true;
      const parametros = {
        idClinica: this.$localStorageService.getIdClinica(),
        idConfiguracion: 3
      }
      this.$http
          .post(
              this.$api +
              "configuracionClinica/obteneValidacionConfiguracionClinica", parametros
          )
          .then((response) => {
            this.blnClinicaDescentralizada = response.data.data;
          }).finally(()=>this.loading = false)
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  }
};
</script>

<style >

</style>
